import React from 'react'
import {Box, Image} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {getGDIHideStyles} from '../../utils/gdi-styles'
import {getExpandedFromContentArea} from '../../utils/gdi-content-area'
import GDILinkBlock from '../gdiLinkBlock'

const GDIImageBlock = ({
    HideBlockOn,
    Image: ImageMobile,
    ImageTablet,
    ImageDesktop,
    ImageAltText,
    LazyLoad,
    MaxWidth,
    Link,
    ...props
}) => {
    const hideStyles = getGDIHideStyles(HideBlockOn)
    if (hideStyles.doNotLoadComponent) return null

    /* Image fields are ContentReferences — Url lives directly on the reference for media
     * assets; Expanded.Url is only populated when CMS expands a child block. */
    const resolveUrl = (ref) => ref?.Url || ref?.Expanded?.Url || null

    const mobileUrl = resolveUrl(ImageMobile)
    const tabletUrl = resolveUrl(ImageTablet) || mobileUrl
    const desktopUrl = resolveUrl(ImageDesktop) || tabletUrl

    if (!mobileUrl) return null

    const linkBlock = getExpandedFromContentArea(Link)

    const imageElement = (
        <Box
            data-block-type="GDIImageBlock"
            sx={hideStyles.sx}
            maxWidth={MaxWidth || '100%'}
            {...props}
        >
            <picture>
                {desktopUrl !== tabletUrl && (
                    <source media="(min-width: 1024px)" srcSet={desktopUrl} />
                )}
                {tabletUrl !== mobileUrl && (
                    <source media="(min-width: 768px)" srcSet={tabletUrl} />
                )}
                <Image
                    src={mobileUrl}
                    alt={ImageAltText || ''}
                    loading={LazyLoad ? 'lazy' : 'eager'}
                    width="100%"
                    height="auto"
                    objectFit="cover"
                />
            </picture>
        </Box>
    )

    if (linkBlock) {
        return <GDILinkBlock {...linkBlock}>{imageElement}</GDILinkBlock>
    }

    return imageElement
}

GDIImageBlock.propTypes = {
    HideBlockOn: PropTypes.string,
    Image: PropTypes.shape({Expanded: PropTypes.shape({Url: PropTypes.string})}),
    ImageTablet: PropTypes.shape({Expanded: PropTypes.shape({Url: PropTypes.string})}),
    ImageDesktop: PropTypes.shape({Expanded: PropTypes.shape({Url: PropTypes.string})}),
    ImageAltText: PropTypes.string,
    LazyLoad: PropTypes.bool,
    MaxWidth: PropTypes.string,
    Link: PropTypes.array
}

export default GDIImageBlock
